
document.addEventListener( 'DOMContentLoaded', function () {
  if ( typeof tns !== 'function' ) return;

  const sliderContainer = document.querySelector( '.kc-resources-slider' );
  if ( !sliderContainer ) return;

  const prevBtn = document.querySelector( '.kc-resources-prev' );
  const nextBtn = document.querySelector( '.kc-resources-next' );

  const slider = tns( {
    container: '.kc-resources-slider',
    items: 1,
    slideBy: 1,
    controls: false,
    nav: false,
    loop: false,
    autoplay: false,
    responsive: {
      768: {
        items: 2
      },
      1024: {
        items: 3
      },
    },
  } );

  const updateUI = ( info ) => {
    const index = info.index;
    const items = info.items;
    const total = info.slideCount;

    let lastIndex = total - items;
    if ( lastIndex < 0 ) lastIndex = 0;

    if ( prevBtn ) prevBtn.disabled = index === 0;
    if ( nextBtn ) nextBtn.disabled = index >= lastIndex;

    const bar = document.querySelector( '.progress-bar .kc-progress' );
    if ( bar && total > 0 ) {
      const base = ( items / total ) * 100;
      let extra = 0;

      if ( lastIndex > 0 ) {
        extra = ( index / lastIndex ) * ( 100 - base );
      }

      let percent = base + extra;
      if ( percent < 0 ) percent = 0;
      if ( percent > 100 ) percent = 100;

      bar.style.width = percent + '%';
    }
  };

  slider.events.on( 'indexChanged', updateUI );

  updateUI( slider.getInfo() );

  if ( prevBtn ) {
    prevBtn.addEventListener( 'click', () => slider.goTo( 'prev' ) );
  }
  if ( nextBtn ) {
    nextBtn.addEventListener( 'click', () => slider.goTo( 'next' ) );
  }
} );
